export const WEEKDAYS = [
  gettext('Понедельник'),
  gettext('Вторник'),
  gettext('Среда'),
  gettext('Четверг'),
  gettext('Пятница'),
  gettext('Суббота'),
  gettext('Воскресенье'),
];

export const ticksToHours = 36000000000;

const addNull = n => n < 10 ? `0${n}` : `${n}`;

const secondsFormat = (sec_num, hideZero) => {
  const format = window.report_time_format;
  if (format === 'SECONDS') {
    return sec_num + gettext(' с');
  }
  if (format === 'MINUTES') {
    return Math.floor(sec_num / 60) + gettext(' м');
  }
  if (hideZero && sec_num === 0) return '';

  let hours = Math.floor(sec_num / 3600);
  const minutes = Math.floor((sec_num - (hours * 3600)) / 60);

  if (format === 'PART_TIME_SEPARATE') { //ЧЧ:MM
    return `${addNull(hours)}:${addNull(minutes)}`;
  }
  const seconds = sec_num - (hours * 3600) - (minutes * 60);
  if (format === 'FULL_TIME_SEPARATE') { //ЧЧ:ММ:CC
    return `${addNull(hours)}:${addNull(minutes)}:${addNull(seconds)}`;
  }

  let days = Math.floor(hours / 24);
  const years = Math.floor(days / 365);
  hours -= days * 24;
  days -= years * 365;

  const time = (years ? years + gettext(' г ') : '') +
    (days ? days + gettext(' д ') : '') +
    addNull(hours) + gettext(' ч ') +
    addNull(minutes) + gettext(' м ') +
    addNull(seconds) + gettext(' с');
  return time;
};

export const ticksFormat = function(ticks, hideZero) {
  const sec_num = Math.ceil(ticks / 10000000);
  return secondsFormat(sec_num, hideZero);
};

export const hoursToTime = function(hours) {

  const days = Math.floor(hours / 24);
  hours %= 24;

  let minutes = hours % 1 * 60;
  let seconds = 0;
  if (days > 0 || hours > 1) {
     minutes = Math.round(minutes);
  } else {
    seconds = Math.round(minutes % 1 * 60);
    minutes = Math.floor(minutes);
  }

  hours = Math.floor(hours);
  const time = (days ? days + gettext('д') : '') +
    (hours ? ` ${hours}`  + gettext('ч') : '') + (minutes ? ` ${minutes}` + gettext('м') : '')
    + (seconds? ` ${seconds}` + gettext('c'): '');
  return time ? time : '0';
};

export const formatTimeSpan = (seconds) =>
  (isNaN(seconds) || !isFinite(seconds)) ? '?' :
  `${String(Math.floor(seconds / 60))}:${
      ('0' + String(Math.floor(seconds % 60))).slice(-2)}`;

export const formatCallDuration = (seconds) => {
  if (isNaN(seconds) || !isFinite(seconds)) {
    return '?';
  }
  return secondsFormat(seconds, null);
};



// WEBPACK FOOTER //
// ./src/common/datetime.js